import React from 'react';
import PlannerInformationLayout
  from 'Views/Page/Content/Templates/PlannerTransitionHouseholdTemplate/Content/PlannerTransitionTableFilters/PlannerInformationPicker/PlannerInformation/PlannerInformationLayout';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import PropTypes from 'prop-types';
import { FDPaper } from '@facet-wealth/design';
import { metaOverrideSet } from './metaOverrideSet';

const PlannerInformation = ({ collection, direction }) => {
  const resource = collection?.resources()?.head();

  if (!resource) {
    return null;
  }

  return (
    <FDPaper padding={100} margin={200}>
      <MetaFormInline
        resource={resource}
        layout={PlannerInformationLayout}
        metaOverrideSet={metaOverrideSet}
        LayoutProps={{
          direction,
        }}
        readonly
      />
    </FDPaper>
  );
};

PlannerInformation.defaultProps = {
  direction: 'column',
};

PlannerInformation.propTypes = {
  collection: PropTypes.object.isRequired,
  direction: PropTypes.oneOf(['row, column']),
};

export default PlannerInformation;
